import React from 'react';
import { RouteComponentProps,withRouter} from 'react-router-dom';
import './Detail.less';
import HwzComponent from '../../common/component/HwzComponent';
import Matter from '../../common/model/matter/Matter';
import { Space, Spin, Tag, Button } from 'antd';
import StringUtil from '../../common/util/StringUtil';
import HwzTitle from '../widget/HwzTitle';
import DownloadToken from '../../common/model/download/token/DownloadToken';
import DateUtil from '../../common/util/DateUtil';
import MessageBoxUtil from '../../common/util/MessageBoxUtil';
import ImageCacheList from './widget/imageCache/ImageCacheList';
import ClipboardUtil from '../../common/util/ClipboardUtil';
import Lang from '../../common/model/global/Lang';
import InfoCell from '../widget/InfoCell';
import HwzContentCard from '../widget/HwzContentCard';
import Color from '../../common/model/base/option/Color';
import { ArrowLeftOutlined } from '@ant-design/icons';
import Moon from '../../common/model/global/Moon';
import SpaceMember from '../../common/model/space/member/SpaceMember';
import { SpaceMemberRole } from '../../common/model/space/member/SpaceMemberRole';

interface RouteParam {
  spaceUuid?: string;
  uuid: string;
}

interface IProps extends RouteComponentProps<RouteParam> {}

interface IState {}

class Detail extends HwzComponent<IProps, IState> {
  matter = new Matter();
  downloadToken = new DownloadToken();
  user = Moon.getSingleton().user;
  spaceMember = new SpaceMember();
  isInSpace = false;
  currentDirUuid: string | null = null;

  constructor(props: IProps) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { spaceUuid, uuid } = this.props.match.params;
    this.matter.uuid = uuid;
    this.matter.spaceUuid = spaceUuid as string | null;
    this.isInSpace = !!spaceUuid;
    
    // 获取当前目录信息（从sessionStorage或URL参数）
    this.currentDirUuid = sessionStorage.getItem('currentDirUuid');
    
    // 如果在空间内，获取用户角色
    if (this.isInSpace && spaceUuid) {
      this.spaceMember.httpMine(spaceUuid, () => {
        this.updateUI();
      });
    }
    
    this.matter.httpDetail((response: any) => {
      this.updateUI();
      if (!response.data.data.dir) {
        this.downloadToken.httpFetchDownloadToken(this.matter.uuid!);
      }
    });
  }

  // 检查下载权限
  checkDownloadPermission(): boolean {
    if (!this.isInSpace) return true;
    
    // 仅预览和上传+预览权限不能下载
    if (this.spaceMember.role === SpaceMemberRole.PREVIEW_ONLY || 
        this.spaceMember.role === SpaceMemberRole.UPLOAD_PREVIEW) {
      return false;
    }
    
    return [SpaceMemberRole.READ_ONLY, SpaceMemberRole.READ_WRITE, SpaceMemberRole.ADMIN].includes(
      this.spaceMember.role!
    );
  }

  // 返回上一页 - 修复逻辑，保持目录位置
  goBack = () => {
    const { spaceUuid } = this.props.match.params;
    
    if (spaceUuid) {
      // 如果在共享空间中，返回到共享空间的文件列表，并保持目录
      let backUrl = `/space/${spaceUuid}/matter/list`;
      
      // 优先使用保存的当前目录信息
      if (this.currentDirUuid) {
        backUrl += `?dirUuid=${this.currentDirUuid}`;
      } 
      // 如果没有保存的目录信息，使用 parent 属性
      else if (this.matter.parent && this.matter.parent.uuid) {
        backUrl += `?dirUuid=${this.matter.parent.uuid}`;
      }
      // 如果查看的是目录本身，返回时应该进入该目录
      else if (this.matter.dir && this.matter.uuid) {
        backUrl += `?dirUuid=${this.matter.uuid}`;
      }
      
      this.props.history.push(backUrl);
    } else {
      // 如果在个人空间中，返回到个人空间的文件列表，并保持目录
      let backUrl = sessionStorage.getItem('previousPath') || '/matter/list';
      
      // 如果有当前目录信息，添加到URL中
      if (this.currentDirUuid) {
        const separator = backUrl.includes('?') ? '&' : '?';
        backUrl += `${separator}dirUuid=${this.currentDirUuid}`;
      }
      // 如果没有保存的目录信息，使用 parent 属性
      else if (this.matter.parent && this.matter.parent.uuid) {
        const separator = backUrl.includes('?') ? '&' : '?';
        backUrl += `${separator}dirUuid=${this.matter.parent.uuid}`;
      }
      // 如果查看的是目录本身，返回时应该进入该目录
      else if (this.matter.dir && this.matter.uuid) {
        const separator = backUrl.includes('?') ? '&' : '?';
        backUrl += `${separator}dirUuid=${this.matter.uuid}`;
      }
      
      this.props.history.push(backUrl);
    }
  };

  recovery() {
    this.matter.httpRecovery(() => {
      this.matter.httpDetail(() => {
        this.updateUI();
      });
      MessageBoxUtil.success(Lang.t('copySuccess'));
    });
  }

  // 获取审批状态标签
  getApprovalTag() {
    const { approval } = this.matter;
    
    switch (approval) {
      case 1: // 等待审批
        return <Tag color={Color.WARNING}>{Lang.t('matter.waitApproval')}</Tag>;
      case 2: // 审批通过
        return <Tag color={Color.SUCCESS}>{Lang.t('matter.approvalPass')}</Tag>;
      case 3: // 审批拒绝
        return <Tag color={Color.DANGER}>{Lang.t('matter.approvalReject')}</Tag>;
      default: // 0或其他，无需审批
        return <Tag color={Color.INFO}>{Lang.t('matter.noneedApproval')}</Tag>;
    }
  }

  getOutsendSTag() {
    const { outsendStatus } = this.matter;
    
    switch (outsendStatus) {
      case 1: // 等待审批
        return <Tag color={Color.WARNING}>{Lang.t('matter.exportAudit')}</Tag>;
      case 2: // 审批通过
        return <Tag color={Color.SUCCESS}>{Lang.t('matter.approvalPass')}</Tag>;
      case 3: // 审批拒绝
        return <Tag color={Color.DANGER}>{Lang.t('matter.approvalReject')}</Tag>;
      default: // 0或其他，无需审批
        return <Tag color={Color.INFO}>{Lang.t('matter.outsendPending')}</Tag>;
    }
  }

  render() {
    const { matter } = this;
    const canDownload = this.checkDownloadPermission();
    
    return (
      <Spin tip={Lang.t('loading')} spinning={matter.detailLoading}>
        <div className="page-matter-detail">
          <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <HwzTitle name={Lang.t('matter.fileDetail')} />
            <Button 
              icon={<ArrowLeftOutlined />} 
              onClick={this.goBack}
              style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', color: 'white' }}
            >
              {Lang.t('back')}
            </Button>
          </div>

          <HwzContentCard>
            <div className="info">
              <InfoCell name={Lang.t('matter.fileInfo')}>
                {matter.name}
                {matter.deleted && (
                  <Tag className="ml10" color={Color.DANGER}>
                    {Lang.t('matter.deleted')}
                  </Tag>
                )}
                <Tag className="ml10">
                  {this.getApprovalTag()}
                </Tag>
                <Tag className="ml10">
                  {this.getOutsendSTag()}
                </Tag>
              </InfoCell>
              <InfoCell name={Lang.t('matter.path')}>{matter.path}</InfoCell>
              <InfoCell name={Lang.t('matter.createTime')}>
                {DateUtil.simpleDateTime(matter.createTime)}
              </InfoCell>
              <InfoCell name={Lang.t('matter.updateTime')}>
                {DateUtil.simpleDateTime(matter.updateTime)}
              </InfoCell>
              {matter.deleted && (
                <InfoCell name={Lang.t('matter.deleteTime')}>
                  {DateUtil.simpleDateTime(matter.deleteTime)}
                </InfoCell>
              )}
              <InfoCell name={Lang.t('matter.uploadUserNickname')}>
                {matter.user.username}
              </InfoCell>
              <InfoCell name={Lang.t('matter.size')}>
                {StringUtil.humanFileSize(matter.size)}
              </InfoCell>
              
              <InfoCell name={Lang.t('matter.uploadApprovalStatus')}>
                {this.getApprovalTag()}
              </InfoCell>
              
              {matter.approvalRemark && (
                <InfoCell name={Lang.t('matter.approvalRemark')}>
                  {matter.approvalRemark}
                </InfoCell>
              )}

              <InfoCell name={Lang.t('matter.outsendApprovalStatus')}>
              {this.getOutsendSTag()}
              </InfoCell>
              
              {matter.outsendRemark && (
                <InfoCell name={Lang.t('matter.approvalRemark')}>
                  {matter.outsendRemark}
                </InfoCell>
              )}

              {!matter.dir ? (
                <>
                  <InfoCell name={Lang.t('matter.publicOrPrivate')}>
                    {matter.privacy
                      ? Lang.t('matter.privateInfo')
                      : Lang.t('matter.publicInfo')}
                  </InfoCell>
                  <InfoCell name={Lang.t('matter.downloadTimes')}>
                    {matter.times}
                  </InfoCell>
                  <InfoCell name={Lang.t('matter.operations')}>
                    <Space>
                      {canDownload && (
                        <a onClick={() => matter.download()}>
                          {Lang.t('matter.download')}
                        </a>
                      )}
                      <a onClick={() => matter.preview()}>
                        {Lang.t('matter.preview')}
                      </a>
                      {matter.deleted ? (
                        <a onClick={() => this.recovery()}>
                          {Lang.t('matter.recovery')}
                        </a>
                      ) : null}
                    </Space>
                  </InfoCell>
                </>
              ) : null}
              {matter.dir && matter.deleted && (
                <InfoCell name={Lang.t('matter.operations')}>
                  <a onClick={() => this.recovery()}>
                    {Lang.t('matter.recovery')}
                  </a>
                </InfoCell>
              )}
            </div>
          </HwzContentCard>
        </div>

        {!matter.dir && matter.uuid && matter.isImage() ? (
          <ImageCacheList initFilter={{ matterUuid: matter.uuid }} />
        ) : null}
      </Spin>
    );
  }
}

export default withRouter(Detail);